/**
 * Control for the map type (Road / Automatic) display
 * @param {Map} map  the Microsoft map reference
 */
define(['bing', 'jquery', 'c21/track'], function (BingMaps, $, track) {
   "use strict";

   return function (map) {
      var self = this,
         BingMaps = window.Microsoft.Maps,

         m_map = map,
         m_jRoad = $("#bingMapTypeRoad"),
         m_jAutomatic = $("#bingMapTypeAutomatic"),
         m_jBE = $("#bingMapTypeBE"),
         m_jAerial = $("#bingMapTypeAerial"),
         clickOption = function (event) {
            event.preventDefault();
            event.data();
         },
         initialize = function () {
            var mapType = m_map.getMapTypeId();

            switch (mapType) {
            case BingMaps.MapTypeId.road:
               self.setRoad();
               break;
            case BingMaps.MapTypeId.birdseye:
               self.setBirdsEye();
               break;
            case BingMaps.MapTypeId.Aerial:
               self.setAerial();
               break;
            default:
               //case BingMaps.MapTypeId.auto:
               self.setAutomatic();
               break;
            }

            m_jRoad.on('click', self.setRoad, clickOption);
            m_jAutomatic.on('click', self.setAutomatic, clickOption);
            m_jBE.on('click', self.setBirdsEye, clickOption);
            m_jAerial.on('click', self.setAerial, clickOption);
         };

      self.setAutomatic = function () {
         track.doEvent('Hybrid Mapping', 'Select Automatic Map View');
         m_map.setMapType(BingMaps.MapTypeId.auto);
         m_jRoad.removeClass("selected").addClass("notSelected");
         m_jAutomatic.addClass("selected").removeClass("notSelected");
         m_jBE.removeClass("selected").addClass("notSelected");
         m_jAerial.removeClass("selected").addClass("notSelected");
      };

      self.setRoad = function () {
         track.doEvent('Hybrid Mapping', 'Select Road Map View');
         m_map.setMapType(BingMaps.MapTypeId.road);
         m_jAutomatic.removeClass("selected").addClass("notSelected");
         m_jRoad.addClass("selected").removeClass("notSelected");
         m_jBE.removeClass("selected").addClass("notSelected");
         m_jAerial.removeClass("selected").addClass("notSelected");
      };

      self.setBirdsEye = function () {
         track.doEvent('Hybrid Mapping', 'Select Bird\'s Eye Map View');
         m_map.setMapType(BingMaps.MapTypeId.birdseye);
         m_jAutomatic.removeClass("selected").addClass("notSelected");
         m_jRoad.removeClass("selected").addClass("notSelected");
         m_jBE.addClass("selected").removeClass("notSelected");
         m_jAerial.removeClass("selected").addClass("notSelected");
      };

      self.setAerial = function () {
         track.doEvent('Hybrid Mapping', 'Select Aerial Map View');
         m_map.setMapType(BingMaps.MapTypeId.aerial);
         m_jAutomatic.removeClass("selected").addClass("notSelected");
         m_jRoad.removeClass("selected").addClass("notSelected");
         m_jBE.removeClass("selected").addClass("notSelected");
         m_jAerial.addClass("selected").removeClass("notSelected");
      };

      initialize();
   };
});
